"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LbModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _useDimension = require("../../hooks/useDimension");
var _classnames = _interopRequireDefault(require("classnames"));
var _LbModalModule = _interopRequireDefault(require("./LbModal.module.css"));
var _excluded = ["content", "onCancel", "outsideDismiss", "closeButton", "variant", "children", "callback", "frameListener"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var LbModal = function LbModal(_ref) {
  var _classNames;
  var content = _ref.content,
    onCancel = _ref.onCancel,
    outsideDismiss = _ref.outsideDismiss,
    closeButton = _ref.closeButton,
    variant = _ref.variant,
    children = _ref.children,
    callback = _ref.callback,
    _ref$frameListener = _ref.frameListener,
    frameListener = _ref$frameListener === void 0 ? null : _ref$frameListener,
    props = _objectWithoutProperties(_ref, _excluded);
  var dimension = (0, _useDimension.useDimension)();
  (0, _react.useEffect)(function () {
    console.log(props, frameListener);
    if (frameListener) {
      window.addEventListener("message", function (e) {
        console.log(e);
        if (e.data === frameListener) {
          callback({
            onCancel: onCancel,
            e: e.data
          });
        }
      });
    }
    return function () {
      if (frameListener) {
        window.removeEventListener("message", function (e) {
          console.log("return ", e);
        });
      }
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, _extends({
    backdrop: outsideDismiss ? outsideDismiss : 'static',
    onHide: onCancel,
    contentClassName: (0, _classnames.default)(_LbModalModule.default.modal, (_classNames = {}, _defineProperty(_classNames, _LbModalModule.default.dark, variant === 'dark'), _defineProperty(_classNames, _LbModalModule.default.light, variant === 'light'), _classNames))
  }, props), children ? children : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (content === null || content === void 0 ? void 0 : content.header) && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    closeButton: closeButton,
    closeVariant: variant ? variant === 'dark' ? 'white' : null : dimension.size === 'chitovic' ? null : 'white',
    className: _LbModalModule.default.header
  }, content.header), (content === null || content === void 0 ? void 0 : content.body) && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: _LbModalModule.default.body
  }, content.body), (content === null || content === void 0 ? void 0 : content.footer) && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, {
    className: _LbModalModule.default.footer
  }, content.footer)));
};

/*LbModal.propTypes = {
  show: PropTypes.bool,
  centered: PropTypes.bool,
  fullscreen: PropTypes.oneOf([
    null,
    'sm-down',
    'md-down',
    'lg-down',
    'xl-down',
    'xxl-down',
    true,
  ]),
  outsideDismiss: PropTypes.bool,
  closeButton: PropTypes.bool,
  variant: PropTypes.oneOf([null, 'dark', 'light']),
  content: PropTypes.object,
};*/
exports.LbModal = LbModal;
LbModal.defaultProps = {
  show: true,
  centered: true,
  outsideDismiss: true,
  closeButton: {
    show: true,
    variant: 'dark'
  },
  content: {
    header: /*#__PURE__*/_react.default.createElement("h1", null, "Title"),
    body: /*#__PURE__*/_react.default.createElement("div", null, "Body"),
    footer: /*#__PURE__*/_react.default.createElement("div", null, "Footer")
  },
  frameListener: null,
  callback: function callback() {
    return console.log("callback");
  }
};